import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-12 md:py-24 bg-mint relative overflow-hidden" data-id="element-204">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-205">
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row" data-id="element-206">
          {/* Image Side */}
          <div className="md:w-2/5 bg-sage/10 p-4 md:p-8 flex items-center justify-center relative" data-id="element-207">
            <div className="absolute inset-0 bg-gradient-to-br from-sage/20 to-transparent pointer-events-none" data-id="element-208"></div>
            <div className="relative z-10 grid grid-cols-2 gap-3 w-full max-w-[280px]" data-id="element-209">
              <img src="https://cdn.magicpatterns.com/uploads/kxzMxXAmgQv1NttwpamgJT/heylloyd-image-1775063615406.png" alt="Protocolo SOS 72H" className="col-span-2 w-full rounded-xl shadow-lg transform -rotate-1" data-id="element-210" />
              <img src="https://cdn.magicpatterns.com/uploads/8pG1KkA9SEhBA5okQsWZ3q/portada_bono_1.png" alt="Bono 1 - Mapa Rápido SOS" className="w-full rounded-lg shadow-md transform rotate-1" data-id="element-211" />
              <img src="https://cdn.magicpatterns.com/uploads/fi7ppZ6bcxiCneCt8MWRei/portada_bono_2.png" alt="Bono 2 - Checklist Restaurantes" className="w-full rounded-lg shadow-md transform -rotate-1" data-id="element-212" />
              <img src="https://cdn.magicpatterns.com/uploads/2badsTisbq4G6GTw6mQLpY/portada_bono_3.png" alt="Bono 3 - Tracker 72H" className="col-span-2 w-1/2 mx-auto rounded-lg shadow-md" data-id="element-213" />
            </div>
          </div>

          {/* Content Side */}
          <div className="md:w-3/5 p-5 md:p-12 flex flex-col justify-center text-center md:text-left" data-id="element-214">
            <FadeIn data-id="element-215">
              <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-6 text-forest" data-id="element-216">
                Tu transformación comienza hoy
              </h2>
              <p className="text-base md:text-lg text-gray-600 mb-4 md:mb-8 leading-relaxed" data-id="element-217">
                Recupera tu abdomen plano y tu energía hoy mismo por una
                fracción de lo que cuesta una consulta nutricional o un
                suplemento de moda que no funciona. Accede al sistema completo
                ahora.
              </p>

              <div className="mb-4 md:mb-6 text-left" data-id="element-218">
                <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-3" data-id="element-219">
                  Incluye:
                </p>
                <ul className="space-y-2 text-sm md:text-base text-gray-700" data-id="element-220">
                  <li className="flex items-center gap-2" data-id="element-221">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-222" />
                    <span data-id="element-223">Protocolo SOS 72H (producto principal)</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-224">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-225" />
                    <span data-id="element-226">Bono #1 — Mapa Rápido SOS: Qué Como Hoy</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-227">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-228" />
                    <span data-id="element-229">
                      Bono #2 — Checklist Anti-Hinchazón en Restaurantes
                    </span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-230">
                    <ShieldCheck className="w-4 h-4 text-sage shrink-0" data-id="element-231" />
                    <span data-id="element-232">Bono #3 — Tracker 72H Claro</span>
                  </li>
                </ul>
              </div>

              <div className="mb-4 md:mb-8 p-4 md:p-6 bg-mint/30 rounded-xl md:rounded-2xl border border-mint inline-block w-full md:w-auto" data-id="element-233">
                <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1" data-id="element-234">
                  Oferta Especial — Todo por solo
                </p>
                <div className="flex items-baseline justify-center md:justify-start gap-2 md:gap-3" data-id="element-235">
                  <span className="text-xl md:text-2xl text-gray-400 line-through font-serif" data-id="element-236">
                    $74 USD
                  </span>
                  <span className="text-4xl md:text-5xl font-bold text-forest font-serif" data-id="element-237">
                    $6,39
                  </span>
                </div>
                <p className="text-xs md:text-sm text-sage font-semibold mt-1" data-id="element-238">
                  ¡Ahorra más del 91%!
                </p>
              </div>

              <div className="flex flex-col items-center md:items-start gap-3" data-id="element-239">
                <Button className="w-full md:w-auto" data-id="element-240" />
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500" data-id="element-241">
                  <ShieldCheck className="w-4 h-4 text-sage" data-id="element-242" />
                  <span data-id="element-243">Descarga instantánea en PDF. Acceso de por vida.</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}